module.exports = __webpack_public_path__ + "img/bar_1.1b4283b9.png";